import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { CompanyState } from './reducers';
import {
  getCompanySettingsLoaded,
  getCompanySettingsProperty,
  getCompanySettings
} from './selectors';
import { LoadCompanySettings } from './actions';
import { tap, filter, take, switchMap } from 'rxjs/operators';
import { CompanySettings } from '../model/company-settings';

function checkCompanySettingsStore(
  store: Store<CompanyState>
): Observable<boolean> {
  return store.select(getCompanySettingsLoaded).pipe(
    tap((loaded: boolean) => {
      if (!loaded) {
        store.dispatch(new LoadCompanySettings());
      }
    }),
    filter((loaded: boolean) => loaded),
    take(1)
  );
}

export function getSettingsFromStore(
  store: Store<CompanyState>
): Observable<CompanySettings> {
  return checkCompanySettingsStore(store).pipe(
    switchMap(() => {
      return store.select(getCompanySettings);
    })
  );
}

export function getPropertyFromSettingsStore(
  store: Store<CompanyState>,
  property: string
): Observable<any> {
  return checkCompanySettingsStore(store).pipe(
    switchMap(() => {
      return store.select(getCompanySettingsProperty(property));
    })
  );
}
